import { ReactElement, ReactNode } from 'react';

import { RefreshIcon } from '../icons/RefreshIcon';

interface Props {
  children: ReactNode;
  showSearch?: boolean;
  reset: () => void;
}

const DentistSearchContainer = ({
  children,
  showSearch = false,
  reset,
}: Props): ReactElement => (
  <section className="mx-5 mt-5 rounded-xl bg-neutral-white px-4 py-4 shadow-card">
    {showSearch && (
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3 border-b border-neutral-lighter pb-3">
        <p className="text-sm font-semibold uppercase text-primary-main">
          Resultado da busca
        </p>
        <button
          className="flex items-center gap-1 rounded-lg px-2 py-1 hover:bg-primary-container"
          onClick={reset}
        >
          <RefreshIcon />
          <span className="text-xs font-semibold uppercase text-primary-main">
            Fazer nova busca
          </span>
        </button>
      </div>
    )}
    {children}
  </section>
);

export default DentistSearchContainer;
